// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"810":"e315d126","3647":"1cc59311","3740":"1cc59311","4127":"8a7c3657","4803":"d600bbc5","7753":"0a687a6b","7815":"8a7c3657","9109":"d600bbc5"}[chunkId] + ".chunk.css";
};